<template>
  <div class="display-input">
    <div class="form-group row">
      <label :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'">
        {{ options.label }}
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
        <input class="form-control" type="text" :value="options.value" readonly/>
      </div>
    </div>
  </div>
</template>

<script>

import Api from '@/vuex/api'
import { toDollarAmount } from '@/util/filters'

export default {
  name: 'DisplayInput',
  props: {
    value: {
      type: [String, Number]
    },
    options: {
      type: Object
    }
  },
  data () {
    return {
      isValid: true
    }
  },
  methods: {
    validate () {
      return true
    },
    async updatePropertyCost (val) {
      let options = {
        lots: val
      }
      let instance = new Api()
      let reportCost = await instance.getPropertyCost(options)
      this.options.value = toDollarAmount(reportCost)
    },
    async updateCompanyDetails (val) {
      let instance = new Api()
      let company = await instance.getCompany(val)
      if (company) {
        if (this.options.label.includes('Phone')) {
          this.options.value = company.accountPhone
        } else if (this.options.label.includes('Email')) {
          this.options.value = company.accountEmail
        } else if (this.options.label.includes('Service Provider')) {
          this.options.value = company.serviceProviderAmount > 0 ? `$${company.serviceProviderAmount}` : `${company.serviceProviderPercent}%`
        }
      } else {
        this.options.value = ''
      }
    },
    runWatcher (val, name) {
      if (this.options.watchers.includes(name)) {
        switch (name) {
          case 'lots':
            if (val) {
              this.updatePropertyCost(val)
            }
            break
          case 'companyName':
            if (val) {
              this.updateCompanyDetails(val)
            }
            break
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/DisplayInput.vue